export default {
      id: "ciel-voile-usage",
      viewBox: "0 0 91 91",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ciel-voile-usage",
      toString: function () {
        return this.url;
      }
    }